export default class EligibilityMessagePriorityAddRequest {
	public eligibilityName: string | null = null;
	public messageOverride: string | undefined | null = null;

	public constructor() {

	}
};